import { render, staticRenderFns } from "./PreWalkthroughScorecard.vue?vue&type=template&id=d671c9a6&scoped=true&"
import script from "./PreWalkthroughScorecard.vue?vue&type=script&lang=js&"
export * from "./PreWalkthroughScorecard.vue?vue&type=script&lang=js&"
import style0 from "./PreWalkthroughScorecard.vue?vue&type=style&index=0&id=d671c9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d671c9a6",
  null
  
)

export default component.exports